import { render, staticRenderFns } from "./StripePaynow.vue?vue&type=template&id=e22443fc&scoped=true&"
import script from "./StripePaynow.vue?vue&type=script&lang=js&"
export * from "./StripePaynow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22443fc",
  null
  
)

export default component.exports